const isDev = () : boolean => {
  const searchParams = new URLSearchParams(window.location.search);
  return !!searchParams.get('dev') || localStorage.getItem('dev-mode') === 'true';
};

export default isDev;
